<style scoped lang="less">
.my-table {
    padding-bottom: 20px;
}
.pagination {
    background: white;
    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 0;
    padding: 10px 15px;
    width: 100%;
}
</style>

<template>
    <div>
        <slot />
        <div class="block my-table">
            <el-pagination class="pagination z-depth-1" :layout="calcLayout()" :total="total"
                @current-change="changePage" :current-page="pageNum+1" :page-size="pageSize">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageNum: 0,
            total: 0,
        };
    },
    props: {
        pageSize: {
            type: Number,
            default: 50,
        },
        firstRequest: {
            type: Boolean,
            default: true,
        },
    },
    // html渲染数据之后，不然无法获取dom
    mounted() {
        if (this.firstRequest) this.fetchData();
    },
    methods: {
        calcLayout() {
            if (this.total == 0) {
                return "prev, pager, next, jumper";
            } else {
                return "total, prev, pager, next, jumper";
            }
        },
        refetchData() {
            if (this.pageNum !== 0) {
                // 这里会直接触发changePage
                this.changePage(1);
            } else {
                this.$emit("fetch-data");
            }
        },

        changePage(page) {
            this.pageNum = page - 1;

            this.$emit("fetch-data");
        },

        submitTotal(total) {
            this.total = total;
        },

        fetchData() {
            this.$emit("fetch-data");
        },
    },
};
</script>
